export const CHANGE_ADMINISTRATIVEHEAD_DATA = 'CHANGE_ADMINISTRATIVEHEAD_DATA';
export const CHANGE_ADMINISTRATIVEHEAD_VALIDATION_PASS = 'CHANGE_ADMINISTRATIVEHEAD_VALIDATION_PASS';
export const SET_USER_ID = 'SET_USER_ID';
export const SET_LOADING = 'SET_LOADING';